import "../styles/pages/mgfellowship.standalone.css";
import { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router";
import { useCyclingIndex } from "../hooks/useCyclingIndex";
import { fellowshipTestimonials } from "../data/testimonials";
import { scrollToSection } from "../utilities/navigation";
import FellowVideoGrid from "../components/programs/FellowVideoGrid";
import FellowshipMarquee from "../components/standalone/FellowshipMarquee";
import FellowshipForm from "../components/standalone/FellowshipForm";
import { ReactComponent as LeftArrow } from "../assets/icons/left_arrow.svg";
import { ReactComponent as RightArrow } from "../assets/icons/right_arrow.svg";
import StickyCTA from "../components/common/StickyCTA";
import hands from "../assets/fellowship/hands.png";
import trainingBg from "../assets/fellowship/training.png";
import skillDevelopmentBg from "../assets/fellowship/skill_development.png";
import schoolsBg from "../assets/fellowship/schools_community.png";
import personalProjectBg from "../assets/fellowship/personal_projects.png";
import makerspacesBg from "../assets/fellowship/makerspaces.png";
import careerOpportunityBg from "../assets/fellowship/career_opportunities.png";
import airquotes from "../assets/fellowship/airquotes.png";
import desktop_arrows from "../assets/fellowship/desktop_arrows.png";
import mobile_tab_arrows from "../assets/fellowship/mobile_tab_arrows.png";
import whoShouldApplyBg1 from "../assets/fellowship/who should apply_1.png";
import whoShouldApplyBg2 from "../assets/fellowship/who should apply_2.png";
import whoShouldApplyBg3 from "../assets/fellowship/who should apply_3.png";
import logo from "../assets/home_page/Logo.svg";
import step1 from "../assets/fellowship/step1.png";
import step2 from "../assets/fellowship/step2.png";
import step3 from "../assets/fellowship/step3.png";
import stars from "../assets/fellowship/stars.svg";
import eligibilityIcon1 from "../assets/fellowship/eligibility_icon-1.png";
import eligibilityIcon2 from "../assets/fellowship/eligibility_icon-2.png";
import eligibilityIcon3 from "../assets/fellowship/eligibility_icon-3.png";
import eligibilityIcon4 from "../assets/fellowship/eligibility_icon-4.png";
import thumbnail5 from "../assets/videos/thumbnail-5.png";
import thumbnail6 from "../assets/videos/thumbnail-6.png";
import thumbnail7 from "../assets/videos/thumbnail-7.png";
import thumbnail8 from "../assets/videos/thumbnail-8.png";
import fellowship_img1 from "../assets/fellowship/fellowship1.png";
import fellowship_img2 from "../assets/fellowship/fellowship2.png";
import fellowship_img3 from "../assets/fellowship/fellowship3.png";
import fellowship_img4 from "../assets/fellowship/fellowship4.png";
import mg_fellowship_logo from "../assets/fellowship/mg_fellowship_logo.png";

// Component for https://makerghatfellowship.makerghat.org
function MGFellowshipSAPage() {
  const fellowshipJourney = [
    {
      image: trainingBg,
      heading: "Training",
    },
    {
      image: schoolsBg,
      heading: "Schools & communities",
    },
    {
      image: makerspacesBg,
      heading: "Makerspaces & kits",
    },
    {
      image: personalProjectBg,
      heading: "Personal projects",
    },
    {
      image: skillDevelopmentBg,
      heading: "Skill development",
    },
    {
      image: careerOpportunityBg,
      heading: "Career opportunities",
    },
  ];

  const fellowshipTestimonialsImages = {
    "image-1": fellowship_img1,
    "image-2": fellowship_img2,
    "image-3": fellowship_img3,
    "image-4": fellowship_img4,
  };

  const eligibilityCriteria = [
    {
      image: eligibilityIcon1,
      title: "Education",
      description: "Graduation in any discipline (STEM/Education preferred)",
    },
    {
      image: eligibilityIcon2,
      title: "Language",
      description: "English plus at least one regional language",
    },
    {
      image: eligibilityIcon3,
      title: "Commitment",
      description: "Willing to live full-time in program regions for two years",
    },
    {
      image: eligibilityIcon4,
      title: "Bonus Skills",
      description:
        "Experience in facilitation, tinkering, or makerspaces preferred (not mandatory)",
    },
  ];

  const commitmentCriteria = [
    "Committed to long-term grassroots transformation",
    "Skilled in hands-on learning and problem-solving",
    "Strong communicators and facilitators",
    "Demonstrated leadership and teamwork potential",
  ];

  const timelineSteps = [
    {
      image: step1,
      step: "Step 1",
      label: "Application",
      description:
        "Showcase your passion, purpose, and vision by filling out the Google form",
      dateLabel: "Deadline",
      date: "April 10th, 2026",
    },
    {
      image: step2,
      step: "Step 2",
      label: "Interview",
      description: "Discuss your goals, readiness, and community alignment",
      dateLabel: "Dates",
      date: "April 20-24, 2026",
    },
    {
      image: step3,
      step: "Step 3",
      label: "Selection",
      description:
        "Final selection based on passion, leadership potential, and mission alignment.",
      dateLabel: "Fellowship Begins",
      date: "May 18th, 2026",
    },
  ];

  const whoShouldApplyImages = [
    whoShouldApplyBg1,
    whoShouldApplyBg2,
    whoShouldApplyBg3,
  ];

  const videos = [
    {
      title: "Strengthening classroom engagement through experiential models.",
      videoId: "06d52ac5-0e58-48ee-b932-d7fd4e566c29",
      thumbnail: thumbnail5,
    },
    {
      title: "Strengthening technical skills for innovation.",
      videoId: "4e9cf0b6-dfb2-4e50-b60b-0b4c350f18d2",
      thumbnail: thumbnail6,
    },
    {
      title: "Learning how to measure change effectively.",
      videoId: "cdbd7539-0444-405f-92ef-e1bb391855b6",
      thumbnail: thumbnail7,
    },
    {
      title: "Growing alongside the communities you serve.",
      videoId: "a4b198b1-7022-40b1-9ce0-101127e828de",
      thumbnail: thumbnail8,
    },
  ];

  const [current, setCurrent] = useState(0);
  const { hash } = useLocation();
  const timelineScrollRef = useRef(null);

  const { quote, author, image } = fellowshipTestimonials[current];

  const idx = useCyclingIndex(fellowshipJourney, 2500);
  const apply_idx = useCyclingIndex(whoShouldApplyImages, 2500);

  const prev = () =>
    setCurrent(
      (c) =>
        (c - 1 + fellowshipTestimonials.length) % fellowshipTestimonials.length,
    );

  const next = () => setCurrent((c) => (c + 1) % fellowshipTestimonials.length);

  const scrollTimelinePrev = () => {
    timelineScrollRef.current?.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollTimelineNext = () => {
    timelineScrollRef.current?.scrollBy({ left: 300, behavior: "smooth" });
  };

  useEffect(() => {
    const sectionID = hash.replace("#", "");
    scrollToSection(sectionID);
  }, [hash]);

  return (
    <>
      <nav className="header flex-jcsb-aic">
        <div>
          <a href="https://makerghat.org" target="_blank" rel="noreferrer">
            <img className="logo" src={logo} alt="Logo" />
          </a>
        </div>
      </nav>
      <div className="mgfellowship-container">
        <div className="section-1">
          <div
            className="journey-slide"
            style={{
              backgroundImage: fellowshipJourney[idx].image
                ? `url(${fellowshipJourney[idx].image})`
                : "none",
            }}
          >
            <div className="fellowship-logo">
              <img src={mg_fellowship_logo} alt="MakerGaon Fellowship Logo" />
            </div>
            {fellowshipJourney.map((item, index) => (
              <img
                key={index}
                src={item.image}
                alt="banner-bg-image"
                className={`journey-bg-img ${index === idx ? "active" : ""}`}
              />
            ))}
            <div className="journey-text">
              <h3 className="label">Your fellowship journey will have</h3>
              <h3 className="title">{fellowshipJourney[idx].heading}</h3>
              <div className="subtext description">
                A two-year leadership fellowship building changemakers for
                grassroots transformation across India.
              </div>
            </div>
          </div>
        </div>

        <div className="section-2">
          <div className="testimonial-wrapper">
            <div className="testimonial-image-panel">
              <img src={fellowshipTestimonialsImages[image]} alt={author} />
            </div>
            <div className="testimonial-quote-panel">
              <img src={airquotes} alt="quote" />
              <div className="subtext testimonial-main-text">{quote}</div>
              <div className="subtext testimonial-main-text">{author}</div>
            </div>
          </div>

          <div className="buttons flex-jcc-aic">
            <LeftArrow onClick={prev} alt="left_arrow" />
            <RightArrow onClick={next} alt="right_arrow" />
          </div>
        </div>

        <div className="section-3">
          <h2 className="section-title">Fellowship curriculum</h2>
          <p className="subtext">
            Equipping fellows with practical skills to lead sustainable
            education and community change.
          </p>
          <FellowVideoGrid videos={videos} />
        </div>

        <div className="section-4">
          <h2 className="section-title">Applications open: 2026–2028 cohort</h2>
          <p className="subtext">
            Selected fellows will begin immersive training and community
            placement in June 2026.
          </p>
          <a
            href={
              "https://docs.google.com/forms/d/e/1FAIpQLScCHD_MN5doivKO0wMjuoC1wgWT4uWZrzv-243hwN5WlIlQ3Q/viewform"
            }
            className="apply"
            target="_blank"
            rel="noreferrer"
          >
            Apply now
          </a>
          <div className="applicant-video">
            <iframe
              className="applicant-iframe"
              src="https://www.youtube.com/embed/2ht4XnE1REI"
              title="Applicant video"
              allowFullScreen
            />
          </div>
        </div>

        <div className="section-5">
          <h2 className="section-title">Fellowship benefits</h2>
          <p className="subtext">
            Grow personally and professionally through structured systemic
            immersion.
          </p>
          <div className="fellowship-marquee-section">
            <div className="fellowship-marquee-container">
              <FellowshipMarquee />
            </div>
          </div>
        </div>

        <div className="section-6">
          <div className="cta-banner-left">
            <h2 className="title">
              Wish to be a part of
              <br />
              the fellowship?
            </h2>
            <a
              href={
                "https://docs.google.com/forms/d/e/1FAIpQLScCHD_MN5doivKO0wMjuoC1wgWT4uWZrzv-243hwN5WlIlQ3Q/viewform"
              }
              className="apply"
              target="_blank"
              rel="noreferrer"
            >
              Click here
            </a>
          </div>
          <img
            src={desktop_arrows}
            alt="desktop-arrows"
            className="desktop-arrows"
          />
          <img
            src={mobile_tab_arrows}
            alt="mobile-tab-arrows"
            className="mobile-tab-arrows"
          />
          <a
            href={
              "https://docs.google.com/forms/d/e/1FAIpQLScCHD_MN5doivKO0wMjuoC1wgWT4uWZrzv-243hwN5WlIlQ3Q/viewform"
            }
            className="apply"
            target="_blank"
            rel="noreferrer"
          >
            Register Now
          </a>
          <img src={stars} className="stars right" alt="stars 1" />
          <img src={stars} className="stars left" alt="stars 2" />
        </div>

        <div className="section-7">
          <h2 className="section-title">Who should apply?</h2>
          <p className="subtext">
            Passionate individuals committed to impact and long-term community
            transformation.
          </p>
          <div className="info-card">
            <div className="info-card-image-panel">
              <img
                src={whoShouldApplyImages[apply_idx]}
                alt="apply-photo"
                loading="eager"
              />
            </div>

            <ul className="info-card-bullets">
              <li>
                <span>Passionate Changemakers</span>
                Eager to drive rural impact while growing personally and
                professionally.
              </li>
              <li>
                <span>Rural Connections</span>
                Have ties to or deep curiosity about rural India.
              </li>
              <li>
                <span>Innovation Mindset</span>
                Ready to design creative, community-rooted solutions.
              </li>
              <li>
                <span>Community Leaders</span>
                Inspired to mobilise others toward collective change.
              </li>
            </ul>
          </div>
        </div>

        <div className="section-8">
          <h2 className="section-title">Eligibility and commitment</h2>
          <p className="subtext">
            We seek committed leaders ready for full-time rural immersion and
            grassroots engagement.
          </p>
          <div className="eligibility-grid">
            {eligibilityCriteria.map((item, index) => (
              <div
                className={`eligibility-item eligibility-item-${index + 1}`}
                key={index}
              >
                <img
                  src={item.image}
                  alt="criteria"
                  className="eligibility-icon"
                />
                <div className="eligibility-title">{item.title}</div>
                <p className="subtext eligibility-text">{item.description}</p>
              </div>
            ))}
          </div>
          <div className="commitment eligibility-grid">
            {commitmentCriteria.map((text, index) => (
              <div
                className={`eligibility-item commitment-item-${index + 1}`}
                key={index}
              >
                <p className="subtext commitment-text">{text}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="section-9">
          <h2 className="section-title">Fellowship selection process</h2>
          <p className="subtext">
            A structured three-step selection process to identify passionate
            changemakers.
          </p>
          <div className="timeline-scroll-wrapper" ref={timelineScrollRef}>
            <div className="timeline-grid">
              {timelineSteps.map((step, index) => (
                <div className="timeline-card" key={index}>
                  <div className="timeline-circle">
                    {step.image && <img src={step.image} alt={step.label} />}
                  </div>
                  <div className="timeline-step-label">
                    <span className="timeline-step-number">{step.step}</span>
                    <span className="timeline-step-name">{step.label}</span>
                  </div>
                  <p className="subtext timeline-step-desc">
                    {step.description}
                  </p>
                  <div className="timeline-step-date">
                    <span className="timeline-date-label">
                      {step.dateLabel}
                    </span>
                    <span className="timeline-date-value">{step.date}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="timeline-nav">
            <div className="buttons flex-jcc-aic">
              <LeftArrow onClick={scrollTimelinePrev} alt="left_arrow" />
              <RightArrow onClick={scrollTimelineNext} alt="right_arrow" />
            </div>
          </div>
        </div>

        <div className="contact" id="contact">
          <div className="contact-content">
            <div className="intro-items">
              <h2 className="section-title title-web">
                We’d love to learn more about you!
              </h2>
              <div className="subtext description">
                Fill the form for any clarification in application or to partner
                for the program.
              </div>
            </div>
            <img src={hands} alt="hands-image" />
          </div>
          <FellowshipForm />
        </div>
        <StickyCTA
          page="mgfellowship"
          mobileCtaText={"Apply now"}
          ctaLink="https://docs.google.com/forms/d/e/1FAIpQLScCHD_MN5doivKO0wMjuoC1wgWT4uWZrzv-243hwN5WlIlQ3Q/viewform"
        />
        <div className="prefetch">
          <img src={trainingBg} alt="" />
          <img src={schoolsBg} alt="" />
          <img src={makerspacesBg} alt="" />
          <img src={personalProjectBg} alt="" />
          <img src={skillDevelopmentBg} alt="" />
          <img src={careerOpportunityBg} alt="" />
          <img src={fellowship_img1} alt="" />
          <img src={fellowship_img2} alt="" />
          <img src={fellowship_img3} alt="" />
          <img src={fellowship_img4} alt="" />
        </div>
      </div>
    </>
  );
}

export default MGFellowshipSAPage;
